import React from 'react';

import LandScapeVideo from '~/components/Video/LandscapeVideo';
import PortraitVideo from '~/components/Video/ProtraitVideo';
import { VideoInterface } from '~/components/Video/types';

const Video = React.memo((props: VideoInterface) => {
  const orientation = props?.orientation;
  const videoWidth = props?.videoWidth;

  if (orientation === 'Portrait') {
    return <PortraitVideo {...props} />;
  }

  return <LandScapeVideo {...props} videoWidth={videoWidth} />;
});

export default Video;
